import {daysBetween, getFormattedMessage, isPlanActive} from "../../../helpers/helpers";
import ReactTimeAgo from "react-time-ago";
import React from "react";

const ExpirationDateItem = ({expirationDate, doesNotExpire, nextRenewalLevelName,
                                hasActiveFreeTrial, freeTrialExpirationDate}) => {
    if (doesNotExpire) {
        return (
            <div className={'plan-item'}>
                {i18n.payments.doesNotExpire}
            </div>
        );
    }

    if (hasActiveFreeTrial && freeTrialExpirationDate) {
        return (
            <div className={'plan-item'}>
                {getFormattedMessage(i18n.payments.freeTrialEnds, new Date(freeTrialExpirationDate).toDateString())}
            </div>
        );
    }

    const hasActivePlan = isPlanActive(expirationDate);
    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));

    if (hasActivePlan && daysUntilExpired >= 0) {
        return (
            <>
                <div className={'plan-item'}>
                    <span className={'indent-text'}>{i18n.payments.expires}</span>
                    {expirationDate &&
                        <span className={'indent-text'}>
                        <ReactTimeAgo date={expirationDate} locale="en-US"/>
                    </span>
                    }
                    ({new Date(expirationDate).toDateString()})
                </div>
                {
                    nextRenewalLevelName && (
                        <div className={'plan-item highlighted'}>{getFormattedMessage(i18n.payments.nextRenewalLevel, nextRenewalLevelName)}</div>
                    )
                }
            </>
        );
    } else if (expirationDate) {
        return (
            <div className={'plan-item'}>
                {getFormattedMessage(i18n.payments.expiredOn, new Date(expirationDate).toDateString())}
            </div>
        );
    }

    return <></>;
};

export default ExpirationDateItem;